export default __webpack_public_path__ + "static/media/Group 4.d741779e.svg";